import * as firebase from 'firebase';

// Creates a firebase object used throughout the application
const config = {
    apiKey: "AIzaSyAAfYGSNr_ewjoFdigoRhvv_IKIj_Nf5y0",
    authDomain: "mozak-b40a7.firebaseapp.com",
    databaseURL: "https://mozak-b40a7.firebaseio.com",
    projectId: "mozak-b40a7",
    storageBucket: "mozak-b40a7.appspot.com",
    messagingSenderId: "1006092584044"
};

const firebaseApp = firebase.initializeApp(config);

export default firebaseApp;



// WEBPACK FOOTER //
// ./src/firebase/firebase.js